__webpack_require__.p = "/fm011-rock-paper-scissors/";